import { useAffiliateTracking } from '../../hooks/useAffiliateTracking';

export const AffiliateTracker = () => {
  useAffiliateTracking();
  return null;
};
